// import wrapWithProvider from "./wrap-with-provider"
// export const wrapRootElement = wrapWithProvider

import React from "react"
import { Provider } from "react-redux"
import { store } from "./src/state/createStore"

export const wrapRootElement = ({ element }) => (
  <Provider store={store}>{element}</Provider>
)
